
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './styles/main.scss';
import { persistor, store } from './store/store';
import React, { Suspense } from "react";
// import { Spinner } from "reactstrap";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";


// const loading = (
//   <div className="pt-3 text-center">
//     <Spinner type="border" className="ms-2" color="primary" />
//     <div>loading...</div>
//   </div>
// );

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Router>
        {/* <Suspense fallback={loading}> */}
        <Suspense>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </Suspense>
      </Router>
    </PersistGate>
  </Provider>
);

reportWebVitals();

